import type { CompanyOrderRow } from "@/lib/staff-api";
import { formatCurrency, formatDate, formatDollars, formatOrderStatus } from "@/lib/formatters";

const TH = "px-3 py-2 text-left font-semibold text-gray-700";
const TD = "px-3 py-2 align-top text-gray-900";

const linesSummary = (o: CompanyOrderRow): string =>
  o.lines ? o.lines.map((l) => `${l.quantity} × ${formatDollars(l.unitPrice)}`).join(", ") : "";

export function OrdersTable({ rows, caption = "Orders" }: { rows: CompanyOrderRow[]; caption?: string }): React.ReactElement {
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
      <table className="min-w-full text-sm">
        <caption className="sr-only">{caption}</caption>
        <thead className="bg-gray-50">
          <tr>
            {["Date", "Order", "Amount", "Employees", "Payment ID", "Card", "Status"].map((h) => (
              <th key={h} scope="col" className={TH}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((o) => (
            <tr key={o.id} className="border-t border-gray-100">
              <td className={TD}>{formatDate(o.createdAt)}</td>
              <td className={TD}>
                {o.typeLabel}
                {o.lines && <span className="block text-gray-600">{linesSummary(o)}</span>}
              </td>
              <td className={TD}>{formatCurrency(o.totalAmount)}</td>
              <td className={TD}>{o.quantity}</td>
              <td className={TD}>{o.vancoTransactionId}</td>
              <td className={TD}>•••• {o.paymentMethodLast4}</td>
              <td className={TD}>
                {formatOrderStatus(o.status)}
                {o.reconcileNeeded && (
                  <span className="ml-2 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-900">Needs reconciling</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
